/**
 * A word from a table by a key the services sent: an event's kind, a
 * failure's reason, an outcome. Text from a payload can be any string,
 * and a plain object answers `constructor` or `toString` with a function
 * of its own; only the table's own keys are read here.
 */
export function lookup<Value>(
    table: Readonly<Record<string, Value>>,
    key: string | null | undefined,
): Value | undefined {
    return key !== null && key !== undefined && Object.hasOwn(table, key) ? table[key] : undefined;
}
